import React from 'react';
import ReactDOM from 'react-dom';
// import { createRoot } from 'react-dom/client';

import './_header';
import './_nav-mobile';
import './_orientation';
import './_ticker';
import './_resize';
import './_cards';
import './_external-links';
import './_carousel-news-events';
import './_interior-carousel';
import './_main-nav'
import './_form';
import './_expand-collapse';
import './_expand-collapse-filter';
import './_sticky-header';
import './_sticky-sidebar';

import NewsEventsLayout from './react/layouts/NewsEventsLayout';
import NewsEventsForm from './react/components/NewsEventsForm';
import NewsEventsCarouselLayout from './react/layouts/NewsEventsCarouselLayout';
import NewsEventsModuleLayout from './react/layouts/NewsEventsModuleLayout';
import RelatedNewsEventsLayout from './react/layouts/RelatedNewsEventsLayout';

const ReactRoot = document.getElementById('react-root');
const NewsEventsModule = document.getElementById('news-events-module');
const NewsEventsCarousel = document.getElementById('news-events-carousel');





if (NewsEventsCarousel) {
  // const NewsEventsCarouselRoot = createRoot(NewsEventsCarousel);
  // eslint-disable-next-line react/jsx-filename-extension
  ReactDOM.render(<NewsEventsCarouselLayout />, NewsEventsCarousel);
  // NewsEventsCarouselRoot.render(<NewsEventsCarouselLayout />);
}

if (ReactRoot) {
  // const ReactRootRoot = createRoot(ReactRoot);
  // eslint-disable-next-line react/jsx-filename-extension
  if (!ReactRoot.hasAttribute('data-app-variant')) {
    ReactDOM.render(<NewsEventsLayout />, ReactRoot);
    // ReactRootRoot.render(<NewsEventsLayout />);
  } else {
    ReactDOM.render(<RelatedNewsEventsLayout />, ReactRoot)
    // ReactRootRoot.render(<RelatedNewsEventsLayout />);
  }
}

if (NewsEventsModule) {
  const NewsEventsModuleRoot = createRoot(NewsEventsModule);
  // eslint-disable-next-line react/jsx-filename-extension
  ReactDOM.render(<NewsEventsModuleLayout />, NewsEventsModule);
  // NewsEventsModuleRoot.render(<NewsEventsModuleLayout />)
}
